// Base URL for hosted files on AWS
const awsAssetPath = "https://decisely-marketing-site-assets.s3.us-west-2.amazonaws.com/";

const deciselyLogo = awsAssetPath+'branding/decisely_logo.svg';
const sidebarLogoWhite = awsAssetPath+'branding/decisely_logo-white.svg';

// Adds img src; prevents error in console if element ID doesn't exist on page (null value)
function elementExists(id, filepath, attr = "") {

    const element = document.getElementById(id);

    if(element) {
        if(attr === "poster"){
            element.poster = filepath;
        } else {
            element.src = filepath;
        }
    }
}

// elementExists("deciselyLoginLogo", deciselyLogo);

export { 
    awsAssetPath
};
